import React from 'react';
import styled from 'styled-components';


/*

Props:


*/

const StyledDiv = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
  /* width: ${props => (props.width) ? props.width : 300}px;
  max-width: ${props => (props.maxWidth) ? props.maxWidth : 300}px; */
  /* height: ${props => (props.height) ? props.height : 300}px; */
    height: 100%;
    overflow: auto;
  `;
  // box-sizing: border-box;

const InteractionModulesSC = ({ styles, onClick, children, ...rest }) => (
  <StyledDiv style = {styles}  onClick = {onClick} className={'InteractionModulesSC'} {...rest} >
      { children }
  </StyledDiv>
)

export default InteractionModulesSC

// color: ${props => (props.color) ? props.color : 'red'};
//   box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);


// WEBPACK FOOTER //
// ./src/js/components/InteractionComponents/InteractionModulesSC.jsx